import { create } from 'zustand';

import { ScenarioSelectionState } from './grant.store';

type Store = {
  decreaseSelectedCount: (scenarioId: string) => void;
  deselectAll: (scenarioId: string) => void;
  increaseSelectedCount: (scenarioId: string) => void;
  scenarioStates: Record<string, ScenarioSelectionState>;
  selectAll: (scenarioId: string, totalCount: number) => void;
  setSelectedItemsCount: (scenarioId: string, count: number) => void;
};

export const useSafeStore = create<Store>((set) => ({
  scenarioStates: {},

  selectAll: (scenarioId, totalCount) =>
    set((state) => ({
      scenarioStates: {
        ...state.scenarioStates,
        [scenarioId]: {
          selectedItemsCount: totalCount,
          isSelectedAll: true,
        },
      },
    })),

  deselectAll: (scenarioId) =>
    set((state) => ({
      scenarioStates: {
        ...state.scenarioStates,
        [scenarioId]: {
          selectedItemsCount: 0,
          isSelectedAll: false,
        },
      },
    })),

  increaseSelectedCount: (scenarioId) =>
    set((state) => {
      const prev = state.scenarioStates[scenarioId] ?? {
        selectedItemsCount: 0,
        isSelectedAll: false,
      };
      return {
        scenarioStates: {
          ...state.scenarioStates,
          [scenarioId]: {
            ...prev,
            selectedItemsCount: prev.selectedItemsCount + 1,
          },
        },
      };
    }),

  decreaseSelectedCount: (scenarioId) =>
    set((state) => {
      const prev = state.scenarioStates[scenarioId] ?? {
        selectedItemsCount: 0,
        isSelectedAll: false,
      };
      return {
        scenarioStates: {
          ...state.scenarioStates,
          [scenarioId]: {
            ...prev,
            selectedItemsCount: Math.max(0, prev.selectedItemsCount - 1),
            isSelectedAll: false,
          },
        },
      };
    }),

  setSelectedItemsCount: (scenarioId, count) =>
    set((state) => {
      const prev = state.scenarioStates[scenarioId] ?? {
        selectedItemsCount: 0,
        isSelectedAll: false,
      };
      return {
        scenarioStates: {
          ...state.scenarioStates,
          [scenarioId]: {
            ...prev,
            selectedItemsCount: count,
          },
        },
      };
    }),
}));
